export default __webpack_public_path__ + "static/media/home (1).659f1253.svg";